import React, {createRef} from "react"

import FinderHeader from '../header/finder-header'

import {finderLoadProjectEvents} from "../functions/load-project-events"
import Event from "../../../model2/event/event"
import ApiSearch from "../../../gd/api/search"
import EventsCollection from "../../../model2/event/collection"
import EventFinderMain from "./event-finder-main"
import {SystemStatusFilter} from "../task/@types";

const MIN_SEARCH_TEXT_LENGTH = 2

type Props = {
    className?          : string

    selectedEventId?    : ID
    parentProjectId?    : ID | null

    noStatusSelector?   : boolean
    noHeader?           : boolean

    onBack?             : func
    onClickEvent?       : {(event: Event): void}
    onClose?            : func
}

type State = {
    search          : string

    isSearching     : boolean
    statusId        : SystemStatusFilter

    parentProjectId : ID | null
    data            : EventsCollection | null
}

const debug = false
// const debug = "EventFinder"

export default class EventFinder extends React.Component<Props, State> {

    private finderRef: any = createRef()
    private delayedEventsSearch: any

    static defaultProps = {
        excludedTasksIds: []
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            search          : '',
            isSearching     : false,
            statusId        : SystemStatusFilter.OPEN,

            parentProjectId : this.props.parentProjectId ? this.props.parentProjectId : null,
            data            : null
        }

        this.delayedEventsSearch = _.debounce(this.eventsSearch, 500)
    }

    componentDidMount() {
        this.loadData()
    }

    componentWillUnmount() {
        this.delayedEventsSearch.cancel()
    }

    loadData = async () => {
        // show root projects list (no data) if no parentProjectId is selected

        let data: any = EventsCollection.initFromJson([])
        if (this.state.parentProjectId) {
            data = await finderLoadProjectEvents(this.state.parentProjectId, this.state.statusId)
        }

        this.setState({
            data: data
        })
    }

    clearData = () => {this.setState({data: null})}

    onSearchChange = (value: string) => {
        const isSearching = value.length >= MIN_SEARCH_TEXT_LENGTH
        if (this.state.search && !value) {
            this.onSearchCancel()
        } else {
            this.setState({
                search      : value,
                isSearching : isSearching,
                data        : null
            }, ()=>{
                if (isSearching) this.delayedEventsSearch()
            })
        }
    }

    onSearchCancel = () => {
        this.clearData()
        this.setState({
            isSearching : false,
            search      : '',
            data        : null
        }, ()=>{this.loadData()})
    }

    eventsSearch = () => {
        if (!this.state.search) {
            this.onSearchCancel()
            return false
        } else if (this.state.search.length < MIN_SEARCH_TEXT_LENGTH) return false

        const request = ApiSearch.events(this.state.search, this.state.statusId)

        request.done((response: any) => {
            this.setState({
                isSearching : false,
                data        : EventsCollection.initFromJson(response.result)
            })
        })

        request.fail((error: any) => {
            this.setState({
                isSearching : false,
                data        : EventsCollection.initFromJson([])
            })
        })
    }

    onClickEvent = (event: Event) => {if (this.props.onClickEvent) this.props.onClickEvent(event)}

    onClickCompany = () => {
        this.setState({
            parentProjectId : null,
            data            : null
        }, ()=>{
            this.loadData()
        })
    }

    onClickProject = (id: ID) => {
        this.setState({
            parentProjectId : id,
            data            : null
        }, ()=>{
            this.loadData()
        })
    }

    onStatusSelect = (value: SystemStatusFilter) => {
        this.setState({
            statusId: value
        }, ()=>{
            if (!this.state.search) this.loadData()
            else                    this.eventsSearch()
        })
    }

    onClose = () => {if(this.props.onClose) this.props.onClose()}

    onKeyDown = (event: any) => {
        this.finderRef.current.onKeyDown(event)
    }

    render() {
        const classes = Classes("gd-finder", this.props.className, {
            'no-header': this.props.noHeader
        })

        debug && console.log(debug, 'render', this.state)

        return (
            <div className={classes}>
                {!this.props.noHeader &&
                    <FinderHeader title             = "Select an event"
                                  inputPlaceholder  = "Search by event name"
                                  search            = {this.state.search}
                                  statusId          = {this.state.statusId}
                                  onBack            = {this.props.onBack}
                                  onSearchChange    = {this.onSearchChange}
                                  onStatusSelect    = {!this.props.noStatusSelector ? this.onStatusSelect : null}
                                  onSearchCancel    = {this.onSearchCancel}
                                  onClose           = {this.onClose}/>}

                <EventFinderMain ref                = {this.finderRef}
                                 data               = {this.state.data}
                                 isSearching        = {this.state.isSearching}
                                 selectedEventId    = {this.props.selectedEventId}
                                 parentProjectId    = {this.state.parentProjectId}
                                 search             = {this.state.search}
                                 onClickCompany     = {this.onClickCompany}
                                 onClickProject     = {this.onClickProject}
                                 onClickEvent       = {this.onClickEvent}/>
            </div>
        )
    }
}